import { SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.667 3v2.667c-4.384.685-6.014 4.525-6.667 8-.025.137 3.59-3.975 6.667-4v2.666L14 7.667 8.667 3Z"
    />
  </svg>
);
export default SvgComponent;
